export default "__VITE_ASSET__b2196c72__"